(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-thanks-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-thanks-container.js');

'use strict';

const {
  useEffect
} = React;
const {
  CharityCard
} = svs.lyckoplatsen.components.shared_charity.react.components;
const {
  activeCharitiesAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useAtomValue
} = jotai;
const CharityThanksContainer = _ref => {
  let {
    charityId
  } = _ref;
  const activeCharities = useAtomValue(activeCharitiesAtom);
  const charity = activeCharities.find(c => c.charityId === charityId);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  return React.createElement("div", {
    className: "lp-page-related-charity-container"
  }, React.createElement("div", {
    className: "lp-singel-charity-card"
  }, React.createElement("p", {
    className: "h2"
  }, "Tack!"), charity && React.createElement(React.Fragment, null, React.createElement("p", null, charity.thankfulMess), React.createElement(CharityCard, {
    charity: charity
  })), !charity && charityId === 0 && React.createElement("p", null, "Ditt spel bidrar via Svenska Spels \xF6verskott till samh\xE4llet och ungdomsidrotten.")));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  CharityThanksContainer
});

 })(window);